































import Vue from 'vue';
import Component from 'vue-class-component';
import _ from 'lodash';
import PopInRetour from './PopInRetour';

const Props = Vue.extend({
	props: {
		hasPopInRetour: {
			type: Boolean,
			required: true
		},
		libellePopInRetour: {
			type: String,
			default: 'Attention, vos modifications vont être perdues. Souhaitez-vous retourner à la liste des vaccinations sans enregistrer ?'
		},
		enableValidation: {
			type: Boolean,
			required: true
		},
		libelleBtn: {
			type: String,
			default: 'Valider'
		},
		bigBtn: {
			type: Boolean,
			default: false
		},
		returnFunction: {
			type: Function,
			default: null
		}
	}
});

@Component({
	components: {
		PopInRetour
	}
})
export default class ValidationBtns extends Props {}
